import {
  applyMiddleware,
  compose,
  legacy_createStore as createStore,
} from 'redux';
import createDebounce from 'redux-debounced';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { ONEDU } from '../constants/ConfigConst';
import rootReducer from './RootReducer';

const persistConfig = {
  key: ONEDU,
  debug: true,
  storage,
};

const middlewares = [thunk, createDebounce()];
const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  persistedReducer,
  {},
  composeEnhancers(applyMiddleware(...middlewares)),
);

const persistor = persistStore(store);

export { persistor, store };
